<template>
  <PageLayout>
    <template #headerTitle>Gestion des notifications</template>

    <VBusHelper :emitOnMounted="$constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH" />

    <!-- HEADER WITH CREATE BUTTON -->
    <div class="flex justify-between items-center mb-6">
      <div class="text-gray-600">
        {{ $stores.notification?.state?.list_all?.list?.length || 0 }} notification(s)
      </div>
      <button
        class="px-6 py-2.5 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 transition-all"
        @click="$bus.emit($constants.EVENTS.NOTIFICATION.CREATE_OR_UPDATE.SHOW, null)"
      >
        + Nouvelle notification
      </button>
    </div>

    <!-- ERROR STATE -->
    <NotificationLoadingError
      v-if="$stores.notification?.state?.list_all?.error"
      @refresh="() => $bus.emit($constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH)"
    >
      <template #errorDescription>
        {{ $stores.notification?.state?.list_all?.error }}
      </template>
    </NotificationLoadingError>

    <!-- NOTIFICATIONS LIST -->
    <div
      v-else-if="$stores.notification?.state?.list_all?.list?.length"
      class="space-y-4"
    >
      <div
        v-for="(notification, index) in $stores.notification?.state?.list_all?.list"
        :key="notification.id || index"
        class="bg-slate-200 rounded-xl p-5 transition-all"
      >
        <div class="flex justify-between items-start gap-4">
          <!-- CONTENT -->
          <div class="flex-1">
            <!-- TITLE & COUNTRY -->
            <div class="flex items-center gap-3 mb-2">
              <h3 class="text-lg font-semibold text-gray-900">{{ notification.title }}</h3>
              <span
                class="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium bg-white text-gray-700"
              >
                {{ $constants.NOTIFICATION.COUNTRIES[notification.country]?.flag }}
                {{ $constants.NOTIFICATION.COUNTRIES[notification.country]?.name }}
              </span>
            </div>

            <!-- DESCRIPTION -->
            <p class="text-base text-gray-600 line-clamp-2">{{ notification.description }}</p>
          </div>

          <!-- ACTIONS -->
          <button
            class="px-4 py-2 rounded-lg bg-white text-gray-700 text-sm font-medium hover:bg-gray-50 transition-all"
            @click="resendNotification(notification)"
          >
            Renvoyer
          </button>
        </div>
      </div>
    </div>

    <!-- LOADING STATE -->
    <div
      v-else-if="$stores.notification?.state?.list_all?.loading"
      class="space-y-4"
    >
      <div
        v-for="i in 3"
        :key="i"
        class="bg-slate-200 rounded-xl p-5 shimmerContainer"
      >
        <div class="h-5 bg-gray-300 rounded shimmerTarget w-3/4 mb-3"></div>
        <div class="h-4 bg-gray-300 rounded shimmerTarget w-1/2 mb-2"></div>
        <div class="h-16 bg-gray-300 rounded shimmerTarget"></div>
      </div>
    </div>

    <!-- EMPTY STATE -->
    <EmptyNotifications
      v-else
      @refresh="() => $bus.emit($constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH)"
    />
  </PageLayout>
</template>

<script>
export default {
  name: 'NotificationsPage',

  methods: {
    resendNotification(notification) {
      // Ouvrir l'éditeur avec les données préremplies, sans l'id pour créer une nouvelle
      const notificationCopy = {
        title: notification.title,
        description: notification.description,
        country: notification.country
      };
      this.$bus.emit(this.$constants.EVENTS.NOTIFICATION.CREATE_OR_UPDATE.SHOW, notificationCopy);
    }
  }
};
</script>
